"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.saveCallbackStatus = void 0;
var material_1 = require("@mui/material");
var react_1 = __importStar(require("react"));
var Button_1 = __importDefault(require("../button/Button"));
var saveCallbackStatus;
(function (saveCallbackStatus) {
    saveCallbackStatus[saveCallbackStatus["none"] = 0] = "none";
    saveCallbackStatus[saveCallbackStatus["success"] = 1] = "success";
    saveCallbackStatus[saveCallbackStatus["error"] = 2] = "error";
})(saveCallbackStatus = exports.saveCallbackStatus || (exports.saveCallbackStatus = {}));
/**
 * @component DialogActionButton
 * @example
 * return (
 *   <DialogActionButton
 *     isEnabled={someBool}
 *     savebuttonText='Save'
 *     saveStatus={saveCallbackStatus.none}
 *     executeSave={handleSave}
 *     handleCallbackSave={handleSaveCallback}
 *     handleCallbackCancel={handleModalClose}
 *   />
 * )
 * @param {boolean} isEnabled is the button enabled
 * @param {string} savebuttonText button to display on the save button
 * @param {string} okButtonType type of the button: "primary", "secondary" or "danger"
 * @param {saveCallbackStatus} saveStatus the saveCallbackStatus
 * @param {boolean} showDeleteButton whether to show a delete button
 * @param {number} spinnerLeftPosition left position of 'processing' spinner on Submit button. If spinner doesn't look centered enter custom value in Rems
 * @param {function} executeSave fn to save
 * @param {function} handleCallbackSave callback save fn
 * @param {function} handleCallbackCancel cancel fn
 * @param {function} executeDelete delete fn
 * @param {boolean} showCancelButton whether to show the cancel button
 */
var DialogActionButton = function (props) {
    var isEnabled = props.isEnabled, savebuttonText = props.savebuttonText, _a = props.okButtonType, okButtonType = _a === void 0 ? "primary" : _a, saveStatus = props.saveStatus, showDeleteButton = props.showDeleteButton, _b = props.spinnerLeftPosition, spinnerLeftPosition = _b === void 0 ? 4 : _b, executeSave = props.executeSave, handleCallbackSave = props.handleCallbackSave, handleCallbackCancel = props.handleCallbackCancel, executeDelete = props.executeDelete, _c = props.showCancelButton, showCancelButton = _c === void 0 ? true : _c;
    var _d = (0, react_1.useState)(false), saveClicked = _d[0], setSaveClicked = _d[1];
    (0, react_1.useEffect)(function () {
        if (handleCallbackSave) {
            if (saveStatus === saveCallbackStatus.success) {
                handleCallbackSave(true);
            }
            else if (saveStatus === saveCallbackStatus.error) {
                handleCallbackSave(false);
            }
        }
    }, [saveStatus, handleCallbackSave]);
    function executeCancel() {
        handleCallbackCancel && handleCallbackCancel();
    }
    function handleSave() {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setSaveClicked(true);
                        return [4 /*yield*/, executeSave()];
                    case 1:
                        _a.sent();
                        setSaveClicked(false);
                        return [2 /*return*/];
                }
            });
        });
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        (executeDelete && showDeleteButton) && (react_1.default.createElement(material_1.Box, { justifyContent: "flex-start", display: "flex", width: '100%' },
            react_1.default.createElement(Button_1.default, { onClick: executeDelete, type: "danger" }, "Delete"))),
        handleCallbackCancel && showCancelButton && (react_1.default.createElement(Button_1.default, { onClick: executeCancel, type: "secondary" }, "Cancel")),
        react_1.default.createElement(Button_1.default, { type: okButtonType, spinnerLeftPosition: spinnerLeftPosition, isSubmitButton: true, disabled: !isEnabled || saveClicked, loading: saveClicked, onClick: function () { handleSave(); } }, savebuttonText)));
};
exports.default = DialogActionButton;
